import script from "./BannerList.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerList.vue?vue&type=script&setup=true&lang=js"

import "./BannerList.vue?vue&type=style&index=0&id=a28f0750&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a28f0750"]])

export default __exports__